import React, { useEffect, useState } from "react";
import { Popup } from "devextreme-react/popup";
import { RadioGroup } from "devextreme-react";
import { OperationDialogFooter, OperationFieldset } from "./OperationDialogParts";

/* Legacy OMD0030 "Resequencing Line Items" dialog. Ids match OMDetailSortBy on the backend. */
const sortByOptions = [
    { id: "RecordNumber", text: "Record # (Entered Order)" },
    { id: "LineNumber", text: "Line #" },
    { id: "Warehouse", text: "WH" },
    { id: "ItemCode", text: "Item Code" },
    { id: "ItemDescription1", text: "Item Description - 1" },
    { id: "InventoryReview", text: "Inventory Review" },
    { id: "LotCode", text: "Lot Code" },
    { id: "OrderedQuantity", text: "Ordered Quantity" },
    { id: "ShippedQuantity", text: "Shipped Quantity" },
    { id: "UnitPrice", text: "Unit Price" },
    { id: "ItemClass", text: "Item Class" },
    { id: "ItemSubclass", text: "Item Subclass" },
];

const directionOptions = [
    { id: false, text: "Ascending" },
    { id: true, text: "Descending" },
];

function SortDetailRecordsPopup({ visible, onClose, onApply }) {
    const [sortBy, setSortBy] = useState("RecordNumber");
    const [descending, setDescending] = useState(false);

    /* Legacy FormCreate: Record # + Ascending selected every time the dialog opens. */
    useEffect(() => {
        if (visible) {
            setSortBy("RecordNumber");
            setDescending(false);
        }
    }, [visible]);

    const handleOk = () => {
        onClose();
        onApply(sortBy, descending);
    };

    return (
        <Popup
            visible={visible}
            onHiding={onClose}
            dragEnabled={true}
            hideOnOutsideClick={false}
            showTitle={true}
            title="Resequencing Line Items"
            width={420}
            height="auto"
            showCloseButton={true}
        >
            <div style={{ padding: "4px 8px 8px 8px" }}>
                <OperationFieldset legend="Resequence Line Items by" first>
                    <RadioGroup
                        items={sortByOptions}
                        value={sortBy}
                        valueExpr="id"
                        displayExpr="text"
                        layout="vertical"
                        className="sort-detail-records-options"
                        onValueChanged={(e) => setSortBy(e.value)}
                    />
                </OperationFieldset>
                <OperationFieldset>
                    <RadioGroup
                        items={directionOptions}
                        value={descending}
                        valueExpr="id"
                        displayExpr="text"
                        layout="horizontal"
                        onValueChanged={(e) => setDescending(e.value)}
                    />
                </OperationFieldset>
                <OperationDialogFooter onOk={handleOk} onCancel={onClose} />
            </div>
        </Popup>
    );
}

export default SortDetailRecordsPopup;
